import { mapSuccess, RemoteData } from '../../reducers/remoteData';
import { SporsmalType } from '../../types/generated-types';
import { toValidNumberString } from '../format';
import { BesvartSporsmal, CurrentSporsmal } from '../reducer/current-steg';
import { Postnummersporsmal } from '../reducer/sporsmalsflyt-types';

export interface CurrentPostnummersporsmal {
    type: SporsmalType.Postnummer;
    sporsmal: Postnummersporsmal;
    postnummer: string;
    poststed: RemoteData<string>;
}

export interface BesvartPostnummersporsmal {
    type: SporsmalType.Postnummer;
    sporsmal: Postnummersporsmal;
    postnummer: string;
    poststed: RemoteData<string>;
}

export const toPoststed = (poststed: string): string => poststed;

export const isBesvartPostnummerSporsmal = (
    besvartSporsmal: BesvartSporsmal,
): besvartSporsmal is BesvartPostnummersporsmal => besvartSporsmal.type === SporsmalType.Postnummer;

export const isCurrentPostnummerSporsmal = (
    currentSporsmal: CurrentSporsmal,
): currentSporsmal is CurrentPostnummersporsmal => currentSporsmal.type === SporsmalType.Postnummer;

export const updateCurrentPostnummerAndPoststed = (
    currentSporsmal: CurrentSporsmal,
    postnummer: string,
    poststed: RemoteData<string>,
): CurrentSporsmal => {
    if (isCurrentPostnummerSporsmal(currentSporsmal)) {
        return {
            ...currentSporsmal,
            postnummer: toValidNumberString(postnummer),
            poststed: mapSuccess(poststed, toPoststed),
        };
    }
    return currentSporsmal;
};
